import { apiInstanceImg } from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const PostImportInfluencer = (id_ean: string, influencer_preview: File) => {
  return apiInstanceImg.post(ApiPathConfig.IMPORT_INFLUENCER(id_ean), {
    influencer_preview,
  })
}

export default PostImportInfluencer
